import React, { forwardRef, useMemo } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import VdooMappingForm from './VdooMappingForm';

const VdooCredentialsForm = forwardRef((props, ref) => {
    const fields = useMemo(() => [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            rules: [urlRegexValidator],
        },
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        },
    ], [])
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={VdooMappingForm}
            initialValue={{ apiEndpoint: 'https://prod.vdoo.io' }}
        />
    )
});

export default VdooCredentialsForm;